import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';
import getIcons from '../../functions/getIcons/getIcons';
import getFonts from '../../functions/getFonts';
import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import CommonService from '../../../../services/commonService';
import { AppData } from '../../../../services';
const Iframe = props => {
  return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : '' }} />;
};
const ContactForm4 = props => {
  let { operator, id, showMap, dashLine, isSanantonio, actions } = props;
  const opname = operator && operator.operator_name;
  const initialState = {
    name: null,
    nameError: null,
    email: null,
    emailError: null,
    phone: null,
    phoneError: null,
    comment: null,
    commentError: null,
  };
  const [state, setState] = useState(initialState);
  const getColor = () => {
    if (opname === 'sanantonio' || opname === 'traveltur') {
      return {
        contactBG: operator && operator.theme_color2,
        dashline: '#fff',
      };
    }
    if (opname === 'tacoha') {
      return {
        contactBG: operator && operator.color_codes.secondary_color,
        dashline: operator && operator.color_codes && operator.color_codes.button_color,
      };
    }
    if (opname === 'liquine') {
      return {
        contactBG: operator && operator.color_codes.header_color,
        dashline: operator && operator.color_codes && operator.color_codes.secondary_color,
      };
    }
    return {
      contactBG: '#161d4f',
      dashline: '#fff',
    };
  };

  const onChange = (value, type) => {
    if (type == 'phone') {
      value = CommonService.phoneNumberFormat(value);
      setState({
        ...state,
        [type]: value,
        [type + 'Error']: false,
      });
    } else {
      setState({ ...state, [type]: value, [type + 'Error']: false });
    }
  };

  const validate = () => {
    let errorCount = 0;
    if (!state.name) {
      setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
      errorCount++;
    } else if (!state.phone) {
      setState({ ...state, phoneError: true, phoneErrorMessage: 'Ingresa tu número de teléfono' });
      errorCount++;
    } else if (!state.email) {
      setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
      errorCount++;
    } else if (state.email && !CommonService.isEMailValid(state.email)) {
      setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
      errorCount++;
    } else if (!state.comment) {
      setState({
        ...state,
        commentError: true,
        commentErrorMessage: 'Inserta tu comentario',
      });
      errorCount++;
    }

    if (errorCount > 0) {
      return false;
    } else {
      return true;
    }
  };


  const pushToDatLayer = () => {

    window.dataLayer.push({
      'event': 'formContacto',
    });

  }

  const onSubmit = () => {
    if (props.andimar) {
      pushToDatLayer();
    }
    if (!validate()) {
      return;
    }

    // pushToDatLayer();



    let data = {
      name: state.name,
      last_name: null,
      email: state.email,
      phone_number: state.phone,
      comments: state.comment,
      operator_id: operator.operator_id,
      operator_name: operator.operator_name,
    };

    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/opsite_contact_info',
        method: 'POST',
        data,
      })
      .then(
        res => onContactInfoResponse(res),
        err => onContactInfoResponse(err),
      );
  };

  const onContactInfoResponse = res => {
    if (res && res.data && res.data.message) {
      setState({
        ...state,
        showModal: true,
        responseMessage: res.data.message,
        status: res.data.status,
      });
    }
  };

  const getIframe = () => {
    if (opname === 'sanantonio') {
      return `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.653754800368!2d-70.0918028!3d-20.2731897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915215192cfe93cd%3A0x2a4432f03e68651!2sLas%20Parcelas%201234%2C%20Alto%20Hospicio%2C%20Tarapac%C3%A1%2C%20Chile!5e0!3m2!1sen!2sin!4v1660722437917!5m2!1sen!2sin" width="100%" height="200" style="border:0; border-radius:10px" allowfullscreen="" loading="lazy"></iframe>`;
    }
    if (opname === 'tacoha') {
      return `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.963165429253!2d-70.6924551!3d-33.4466965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c45dfaf0828d%3A0x36716f555c559cc!2sAp%C3%B3stol%20Santiago%20386%2C%208500995%20Quinta%20Normal%2C%20Regi%C3%B3n%20Metropolitana%2C%20Chile!5e0!3m2!1sen!2sus!4v1624087497051!5m2!1sen!2sus" width="100%" height="200" style="border:0; border-radius:10px" allowfullscreen="" loading="lazy"></iframe>`;
    }
    if (opname === 'traveltur') {
      return `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.377759740472!2d-70.65124399999999!3d-33.43946340000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c5a3f56e4607%3A0x2a8a8976a151a288!2sHuerfanos%201055%2C%20Santiago%2C%20Regi%C3%B3n%20Metropolitana%2C%20Chile!5e0!3m2!1sen!2sin!4v1688407960571!5m2!1sen!2sin" width="100%" height="200" style="border:0;"  border-radius:10px" allowfullscreen="" loading="lazy" "></iframe>`;
    }
    if (opname === 'liquine') {
      return null;
    }
    return `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.268741576728!2d-70.6963341852367!3d-33.442304304479485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c467e3d139b9%3A0xeef42616c7bc46f0!2sAndimar%20Vip!5e0!3m2!1sen!2sin!4v1642448360398!5m2!1sen!2sin" width="100%" height="200" style="border:0; border-radius:10px" allowfullscreen="" loading="lazy"></iframe>`;
  };

  return (
    <div className="contact-form w-50 montserrat-bold ">
      {showMap && getIframe() && (
        <div
          style={{
            height: 200,
            width: '100%',
            // background: '#43469C',
            marginBottom: 30,
            borderRadius: 10,
          }}
        >
          <Iframe iframe={getIframe()} />
        </div>
      )}
      {/* <div className="contact-form__head text-uppercase px-5 py-3 montserrat-bold font12">CONTÁCTANOS</div> */}
      <div
        className="contact-form__head text-uppercase  px-5 py-3 favorite-destinations-heading d-flex align-center  montserrat-bold font12"
        style={{
          background: getColor().contactBG,
        }}
      >
        {/* <span className="d-inline-block title-dash-line"></span> */}
        <div
          className="px-2 text-uppercase m-0 bold-text"
        // style={{ color: operator.theme_color2 && operator.theme_color2 }}
        >
          {'CONTÁCTANOS'}
        </div>
        {dashLine && (
          <span
            className="d-inline-block title-dash-line"
            style={{ background: getColor().dashline }}
          ></span>
        )}
      </div>
      <div
        className="contact-form__container py-4"
        style={{ background: isSanantonio ? '#F4F4F4' : '' }}
      >
        {/* <form> */}
        <div className="form-group w-100 px-5 montserrat">
          <label
            className="w-100"
            htmlFor=""
            style={{
              color:
                isSanantonio && 
                operator&&
                operator.color_codes &&
                operator.color_codes.sub_footer_color &&
                operator.color_codes.sub_footer_color,
            }}
          >
            Nombre
          </label>
          <input
            type="text"
            className="w-100 montserrat-bold p10"
            placeholder="Ej.Pedro"
            onChange={event => onChange(event.target.value, 'name')}
          />
        </div>
        <div className="form-group w-100 px-5 montserrat-bold">
          <label
            className="w-100"
            htmlFor=""
            style={{
              color:
                isSanantonio &&
                operator&&
                operator.color_codes &&
                operator.color_codes.sub_footer_color &&
                operator.color_codes.sub_footer_color,
            }}
          >
            Teléfono
          </label>
          <input
            type="number"
            className="w-100 montserrat-bold p10"
            placeholder="+56 9 0000 0000"
            onChange={event => onChange(event.target.value, 'phone')}
          />
        </div>
        <div className="form-group w-100 px-5">
          <label
            className="w-100 "
            htmlFor=""
            style={{
              color:
                isSanantonio &&
                operator&&
                operator.color_codes &&
                operator.color_codes.sub_footer_color &&
                operator.color_codes.sub_footer_color,
            }}
          >
            Email
          </label>
          <input
            type="email"
            className="w-100 montserrat-bold p10"
            placeholder="ejemplo@gmail.com"
            onChange={event => onChange(event.target.value, 'email')}
          />
        </div>
        <div className="form-group w-100 px-5 montserrat">
          <label
            className="w-100"
            htmlFor=""
            style={{
              color:
                isSanantonio &&
                operator&&
                operator.color_codes &&
                operator.color_codes.sub_footer_color &&
                operator.color_codes.sub_footer_color,
            }}
          >
            Comentario
          </label>
          <input
            type="text"
            className="w-100 montserrat-bold p10"
            placeholder="Opcional"
            onChange={event => onChange(event.target.value, 'comment')}
          />
        </div>
        {/* <div className="form-group w-100 px-5">
            <label className="w-100" htmlFor="">
              Comentario
            </label>
            <textarea
              type="text"
              className="w-100 montserrat font9"
              rows="3"
              placeholder="Optional"
            />
          </div> */}
        <div className="form-group w-100 px-5 ">
          <button
            className="w-100 less-bold-text"
            style={{
              background: operator && operator.color_codes && operator.color_codes.button_color,
            }}
            onClick={() => onSubmit()}
          >
            ENVIAR
          </button>
        </div>
        {/* </form> */}
      </div>
      <KuposErrorSuccessModal
        success={state.status == 200 ? true : false}
        showModal={state.showModal}
        onButtonClick={() => {
          setState({ showModal: false });
          window.location.reload();
        }}
        bodyText={state.responseMessage}
      />
    </div>
  );
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
    common: state.common,
  };
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...actions, ...commonActions, ...serviceActions, ...myAccountActions },
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactForm4);



// WEBPACK FOOTER //
// ./src/features/themes/common/contact/ContactForm4.js